import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Form } from "react-bootstrap";
import { NotifierService } from "../../shared/services/notifier.service";
import { AuthenticateService } from "./authenticate.service";
import { CacheService } from "../../shared/services/cache.service";
import "./login.scss";
import { withRouter } from "react-router";
import Button from "../../components/button/button";
import { SpinnerService } from "../../shared/services/spinner.service";
import { ForgetPasswordModal } from "../modals/forgetpassword";
import { Header } from "../../components/header/header";

interface LoginState {
  show?: any;
  username?: any;
  password?: any;
}

class LoginComponent extends Component<any, LoginState> {
  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      username: null,
      password: null,
    };
  }

  async componentDidMount() {
    //Auto login in case of already logged in.
    const token = CacheService.get("security", "token");

    if (token) {
      try {
        CacheService.putIntoSession("security", "token", token);
        const user = await AuthenticateService.refreshUser();
        this.showWorkspace(user);
      } catch (e) {
        CacheService.putIntoSession("security", "token", null);
        CacheService.put("security", "token", null);
        NotifierService.error("Unable to find credentials. Please login!!!");
      }
    }
  }

  handleInputChange = (event: any) => {
    const target = event.target;
    var value = target.name === "rememberMe" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
  };

  closeForgotPasswordModal = () => {
    return this.setState({ show: false });
  };

  openForgotPasswordModal = () => {
    return this.setState({ show: true });
  };

  authenticate = async () => {
    let state: any = this.state;
    const username = state.username;
    const password = state.password;
    const rememberMe = state.rememberMe;
    try {
      SpinnerService.show();
      const user = await AuthenticateService.authenticate(
        username,
        password,
        rememberMe
      );
      this.showWorkspace(user);
      SpinnerService.hide();
    } catch (e) {
      SpinnerService.hide();
      NotifierService.error(e.message || "Invalid username or password.");
      AuthenticateService.clear();
    }
  };

  handleKeypress = (e: any) => {
    if (e.key === "Enter") {
      this.authenticate();
    }
  };

  showWorkspace = (user: any) => {
    if (user) {
      this.props.showWorkspace({ user });
    }
  };

  render() {
    return (
      <div className="main_content">
        <Container fluid={true}>
          <Row>
            <Col xs={12}>
              <Header></Header>
            </Col>
          </Row>
          <Row>
            <Col sm={12} xs={12} md={12} className="sign-in-container">
              <Row className="light-background sign-in-heading-row">
                <Col
                  xs={12}
                  className="panel-heading text-color sign-in-heading p-2"
                >
                  <img
                    src="/images/user.png"
                    className="user-icon"
                    alt="user icon"
                  />
                  &nbsp; Welcome to AFS Secure Access Area
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="panel-body padding-bottom-zero">
                  <Form id="frmAuthenticate">
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name="username"
                        onChange={this.handleInputChange}
                        onKeyPress={this.handleKeypress}
                        placeholder="Username or Email"
                        id="username"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        type="password"
                        name="password"
                        onChange={this.handleInputChange}
                        onKeyPress={this.handleKeypress}
                        placeholder="Password"
                        id="password"
                      />
                    </Form.Group>
                    {/*  We are not using this yet
                      <Form.Group controlId="formBasicCheckbox">
                      <Form.Check
                        type="checkbox"
                        name="rememberMe"
                        className="remember-now"
                        label={` Keep me signed in`}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>  */}
                    <Form.Group>
                      <Button
                        value="Sign In"
                        className="btn-default"
                        onClick={() => {
                          this.authenticate();
                        }}
                      ></Button>
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <ForgetPasswordModal
          show={this.state.show}
          closeForgotPasswordModal={this.closeForgotPasswordModal}
        />
      </div>
    );
  }

  static properties = (state: any) => {
    return {
      user: state.app.user,
    };
  };

  static dispatchers = (dispatch: any) => {
    return {
      showWorkspace: (payload: any) => {
        dispatch({ type: "AUTHENTICATED", payload });
      },
    };
  };
}

export const Login = connect(
  LoginComponent.properties,
  LoginComponent.dispatchers
)(withRouter(LoginComponent));
